import { render, staticRenderFns } from "./step1.vue?vue&type=template&id=3c829ae0&scoped=true"
import script from "./step1.vue?vue&type=script&lang=ts"
export * from "./step1.vue?vue&type=script&lang=ts"
import style0 from "./step1.vue?vue&type=style&index=0&id=3c829ae0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c829ae0",
  null
  
)

export default component.exports